import React from 'react';
import { Package, BookOpen, Lock } from 'lucide-react';
import PhasePageTemplate from './PhasePageTemplate';

const PhaseDelivery = () => (
  <PhasePageTemplate
    phaseNumber="04"
    phaseName="Secure Delivery"
    tagline="Your machine ships configured, encrypted, and tested. You plug it in — and it's ready."
    heroImage="/images/generated/process-hero-delivery.png"
    conceptImage="/images/generated/process-concept-delivery.png"
    delivers={[
      {
        icon: <Package className="w-6 h-6" />,
        title: 'Your Hardware, at Your Door',
        desc: 'A dedicated Apple machine — your agent\'s home. Shipped directly to your facility. No setup required on your end. Plug in and connect.',
      },
      {
        icon: <BookOpen className="w-6 h-6" />,
        title: 'Your Welcome Package',
        desc: 'A printed quick-start guide, tailored to your agent. Your first prompts, your setup checklist, and everything you need to hit the ground running.',
      },
      {
        icon: <Lock className="w-6 h-6" />,
        title: 'A Hardened Machine',
        desc: 'Disk encryption enabled. Separate accounts for your agent and your admin. The machine is locked down before it leaves us — your data stays on your hardware.',
      },
    ]}
    whyTitle="We don't ship you a setup project."
    whyBody="Everything is configured before it leaves us. Encryption, integrations, your agent's identity — all live and tested. The welcome package in the box is your guide to activation, not a manual for setup. We've done roofing software before. We know how little time you have. So we do as much as possible before the machine leaves our hands, and we make the rest as simple as a conversation."
    experienceTitle="A box arrives. You open it, you plug it in."
    experienceBody="That's most of it. Inside the box is your machine and a welcome package. The package has your first prompts, your quick-start guide, and the instructions for your Activation Call — the 3-hour session where we go live together. You don't need to configure anything before that call. Just unbox it, plug it in, and we'll take care of the rest when we're on the call together."
    experienceHighlights={[
      'Arrives pre-configured — no IT required, no open ports',
      'Welcome package inside includes your quick-start prompts',
      'Activation Call scheduled before your machine ships — no waiting',
    ]}
    timeline="3–5 business days in transit"
    mockupImage="/images/generated/mockup-vito-email.jpg"
    mockupCaption="You'll hear from us — proactive updates, every step of the build."
    todoItems={[
      'Accept the delivery',
      'Unbox and plug the machine into power',
      'Hold on to your welcome package — you\'ll use it on the Activation Call',
    ]}
    prevPhase={{ name: 'Building Your Agent', href: '/process/build' }}
    nextPhase={{ name: 'The Activation Call', href: '/process/activation' }}
  />
);

export default PhaseDelivery;
